import { render } from "./chghost.vue?vue&type=template&id=40aa8e30&ts=true"
import script from "./chghost.vue?vue&type=script&lang=ts"
export * from "./chghost.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Users\\orson\\coding\\thelounge\\thelounge\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/MessageTypes/chghost.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40aa8e30"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40aa8e30', __exports__)) {
    api.reload('40aa8e30', __exports__)
  }
  
  module.hot.accept("./chghost.vue?vue&type=template&id=40aa8e30&ts=true", () => {
    api.rerender('40aa8e30', render)
  })

}


export default __exports__